import momenJalaali from "moment-jalali";
import { faBroom, faHeadset } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { CardText, EmojiAngry, EyeFill, EyeSlashFill, FileEarmarkExcelFill, Headset, List, Search } from "react-bootstrap-icons";
import { searchServiceForHappyCall, getHappyCallStatusList } from "../store/api/HappycallAPI";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker2";
import BihamtaTable from "../../Components/BihamtaTable";
import { useEffect, useRef, useState } from "react";
import { getServiceStatusList } from "../store/api/ServiceAPI";
import Loader from "react-loader-spinner";
import ModalHappyCall from "../../Components/Modals/ModalHappyCall";
import { exportToExcel, keyIsLetterOrNumber } from "../../store/api/CommonFunctions";
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import ModalProducts from "../../Components/Modals/ModalProducts";
import { getSystemSettings } from "../../Services/store/api/SystemSettingsAPI";

const HappyCallServiceList = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [modalHappyCall, setModalHappyCall] = useState({ show: false });
    const { filterData, systemSettings } = useSelector(state => {
        return {
            filterData: state.happycallDataReducer.happyCallServiceFilters,
            systemSettings: state.SystemSettingsReducer.systemSettings
        }
    });
    const { handleSubmit, register } = useForm();
    const [showFilter, setShowFilter] = useState(true);
    const [hcStatusList, setHCStatusList] = useState(null);
    const [selectedStaff, setSelectedStaff] = useState(null);
    const [popStaff, setPopStaff] = useState({ show: false });
    const [popProduct, setPopProduct] = useState({ show: false });
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [popCustomer, setPopCustomer] = useState({ show: false });
    const [serviceStatusList, setServiceStatusList] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [dateFilters, setDateFilters] = useState({
        FirstContactDate: filterData?.FirstContactDate,
        ContactDateTo: filterData?.ContactDateTo,
        HappyCallDateFrom: filterData?.HappyCallDateFrom,
        HappyCallDateTo: filterData?.HappyCallDateTo
    });
 const pgType = Number(systemSettings?.find?.(s => s.SettingName === "ProductGrouppingType")?.SettingValue ?? 1);

    const settingNames = ['ProductGrouppingType'];
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "نام نماینده", colName: "AgentName" },
        { colTitle: "تاریخ پذیرش", colName: "PFirstContactDate", showInMobile: true },
        { colTitle: "تاریخ تحویل/ارسال", colName: "PSendDeliverDate" },
        { colTitle: "تاریخ رضایت سنجی", colName: "PHappyCallDate", showInMobile: true },
        { colTitle: "نوع سرویس", colName: "PServiceType" },
        { colTitle: "شماره سرویس", colName: "InvoiceNumber" },
        { colTitle: "مارک محصول", colName: "ProductHolderName", showCondition: () => pgType !== 1 },
        { colTitle: (pgType === 1 ? "نام محصول" : "نوع محصول"), colName: "ProductName" },
        { colTitle: "مدل محصول", colName: "ProductModel" },
        { colTitle: "شماره سریال", colName: "ProductSerial", style: { fontFamily: "Dark-Sans", fontSize: "11.5px" } },
        { colTitle: "نام مشتری", colName: "CustomerName" },
        { colTitle: "همراه مشتری", colName: "CustomerMobile" },
        { colTitle: "تلفن مشتری", colName: "CustomerPhone" },
        { colTitle: "کد مشتری", colName: "CustomerCode" },
        { colTitle: "وضعیت سرویس", colName: "Status" },
        { colTitle: "وضعیت رضایت سنجی", colName: "HappycallStatus" },
        { colTitle: "نام کاربر", colName: "HappycallByName" },
        { colTitle: "رضایت سنجی شده", colName: "HappyCallSaved", colType: "boolean" },
        { colTitle: "بایگانی شده", colName: "IsArchive", colType: "boolean" }
    ]
    const rowButtons = [
        { type: "common", icon: <Headset size={19} color="#0ea053" className="rowBtn" />, tooltip: "رضایت سنجی", text: "رضایت سنجی", onclick: showModalHappyCall },
        { type: "common", icon: <EmojiAngry size={19} color="#ff551a" className="rowBtn" />, tooltip: "شکایت", text: "شکایت", onclick: gotoComplaint },
        { type: "common", icon: <CardText size={19} color="#1a48ffff" className="rowBtn" />, tooltip: "نمایش سرویس", text: "نمایش سرویس", onclick: gotoService }
    ]

    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({});
        dispatch(searchServiceForHappyCall({ Take: 10, Skip: 0 }));
    }
    function search(data) {
        const firstContactDate = document.getElementsByName("FirstContactDate")[0].value;
        if (firstContactDate !== "") {
            data.FirstContactDate = dateFilters.FirstContactDate;
        }
        else {
            dateFilters.FirstContactDate = null;
        }
        const contactDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (contactDateTo !== "") {
            data.ContactDateTo = dateFilters.ContactDateTo;
        }
        else {
            dateFilters.ContactDateTo = null;
        }
        const happyCallDateFrom = document.getElementsByName("HappyCallDateFrom")[0].value;
        if (happyCallDateFrom !== "") {
            data.HappyCallDateFrom = dateFilters.HappyCallDateFrom;
        }
        const happyCallDateTo = document.getElementsByName("HappyCallDateTo")[0].value;
        if (happyCallDateTo !== "") {
            data.HappyCallDateTo = dateFilters.HappyCallDateTo;
        }
        else {
            dateFilters.HappyCallDateTo = null;
        }
        data.Take = 10;
        data.Skip = 0;
        dispatch(searchServiceForHappyCall(data));
    }
    function showModalHappyCall(row) {
        setModalHappyCall({
            show: true,
            ProductID: row.ProductID,
            ServiceType: row.ServiceType,
            ServiceID: row.ServiceID,
            ProductName: row.ProductName,
            ProductModel: row.ProductModel,
            InvoiceNumber: row.InvoiceNumber,
            PServiceType: row.PServiceType,
            ProductSerial: row.ProductSerial,
            CustomerPhone: row.CustomerPhone,
            CustomerMobile: row.CustomerMobile,
            CustomerName: row.CustomerName,
            ContactDate: row.PFirstContactDate,
            SendDeliveryDate: row.PSendDeliverDate
        })
    }
    function gotoService(row) {
        window.open(`/Services/Service/${row.ServiceID}/${row.ServiceType}`);
    }
    function gotoComplaint(row)
    {
        history.push(`/CRM/Complaint/0/${row.ServiceType}/${row.ServiceID}`);
    }
    function toExcel() {
        const url = "api/HappycallAPI/SearchServiceForHappyCall";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("HappyCallServiceList", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function showModalCustomer(e) {
        if (filterData) {
            filterData.CustomerID = null;
            filterData.CustomerName = null;
        }
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        setPopCustomer({ show: true, value: e.key, invoiceCustomers: false, justForSelect: true, setCustomerData: setSelectedCustomer });
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        if (filterData) {
            filterData.AgencyID = null;
            filterData.AgencyName = null;
        }
        setPopStaff({ show: true, forAgency: true, onSelect: setSelectedStaff });
    }
    function onSelectInputChange(e) {
        const name = e.target.name?.toLowerCase();
        const value = e.target.value;
        if (name === "customername") {
            if (filterData) {
                filterData.CustomerID = null;
                filterData.CustomerName = value;
            }
            setSelectedCustomer({ Name: value });
        }
        else if (name === "agencyname") {
            if (filterData) {
                filterData.AgencyID = null;
                filterData.AgencyName = value;
            }
            setSelectedStaff({ LastName: value });
        }
    }
    function showModalProduct(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        if (filterData) {
            filterData.ProductID = null;
            filterData.ProductName = null;
        }
        const onSelect = (data) => {
            if (data) {
                const prd = [data.HolderName, data.ProductName, data.ProductModel];
                data.ProductName = prd.filter(p => p?.length > 0).join("-");
            }
            setSelectedProduct(data);
        }
        setPopProduct({ show: true, value: e.key, setProductData: onSelect });
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-مشتریان";
        getServiceStatusList(setServiceStatusList);
        getHappyCallStatusList(setHCStatusList);
        dispatch(getSystemSettings(settingNames));
    }, [])
    return (
        <div className="container-fluid mt-1">
            <br />
            <Card>
                <ModalHappyCall popData={modalHappyCall} setPopData={setModalHappyCall} />
                <ModalSelectCustomer popData={popCustomer} setCustomerPopup={setPopCustomer} />
                <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} hideNewProduct={true} />
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faHeadset} size="lg" />&nbsp;
                    رضایت سنجی مشتریان
                </Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <form ref={frmFilters} readOnly onSubmit={handleSubmit(search)}>
                        <Row className="rowBorder" id="divFilters">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>نمایندگی: </label>
                                <input type='hidden' name="AgencyID" value={selectedStaff?.ID ?? filterData?.AgencyID ?? ""} ref={register({})} readOnly />
                                <input className="search-input" ref={register({})} name="AgencyName" value={selectedStaff?.LastName ?? filterData?.AgencyName ?? ""} onChange={onSelectInputChange} />
                                <Button className="btn-input-tiny" style={{ top: 22, left: 14 }} onClick={showModalStaff}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>رضایت سنجی: </label>
                                <select className="search-input" ref={register({})} name="HappyCallSaved" defaultValue={filterData?.HappyCallSaved ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>رضایت سنجی نشده</option>
                                    <option value={true}>رضایت سنجی شده</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>محصول: </label>
                                <input type="hidden" ref={register({})} name="ProductID" value={selectedProduct?.ProductID ?? filterData?.ProductID ?? ""} />
                                <input className="search-input" ref={register({})} name="ProductName" value={selectedProduct?.ProductName ?? filterData?.ProductName ?? ""} />
                                <Button className="btn-input-tiny" onClick={showModalProduct} style={{ top: 22, left: 14 }}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره سریال: </label>
                                <input className="search-input" ref={register({})} name="SerialNumber" defaultValue={filterData?.SerialNumber ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>توضیحات: </label>
                                <input className="search-input" ref={register({})} name="HappycallDesc" defaultValue={filterData?.HappycallDesc ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مشتری:</label>
                                <input type="hidden" name="CustomerID" ref={register({})} readOnly value={selectedCustomer?.ID ?? filterData?.CustomerID ?? ""} />
                                <input className="search-input" ref={register({})} name="CustomerName" value={selectedCustomer?.Name ?? filterData?.CustomerName ?? ""} onChange={onSelectInputChange} />
                                <Button className="btn-input-tiny" onClick={showModalCustomer} style={{ top: 22, left: 14 }}><List size={17} /></Button>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت سرویس: </label>
                                {
                                    !Array.isArray(serviceStatusList ?? "") &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" color="#bb1370" width={20} height={20} style={{ display: "inline-block" }} /> &nbsp;
                                        در حال بارگذاری لیست
                                    </div>
                                }
                                {
                                    serviceStatusList && Array.isArray(serviceStatusList) &&
                                    <select className="search-input" name="StatusID" ref={register({})} defaultValue={filterData?.StatusID ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        {serviceStatusList.map((st, i) => <option key={i} value={st.ID}>{st.Status}</option>)}
                                    </select>
                                }

                            </Col>
                            <Col md={2} className="form-group">
                                <label>وضعیت رضایت سنجی: </label>
                                {
                                    !Array.isArray(hcStatusList?.Data ?? "") &&
                                    <div className="search-input">
                                        <Loader type="BallTriangle" color="#bb1370" width={20} height={20} style={{ display: "inline-block" }} /> &nbsp;
                                        در حال بارگذاری لیست
                                    </div>
                                }
                                {
                                    hcStatusList?.Data && Array.isArray(hcStatusList.Data) &&
                                    <select className="search-input" name="ServiceStatusForHappyCall" ref={register({})} defaultValue={filterData?.ServiceStatusForHappyCall ?? ""}>
                                        <option value="">انتخاب کنید</option>
                                        {hcStatusList.Data.map((st, i) => <option value={st.ID} key={i}>{st.InfoName}</option>)}
                                    </select>
                                }
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام کاربر: </label>
                                <input className="search-input" ref={register({})} name="HappyCallByName" defaultValue={filterData?.HappyCallByName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نوع سرویس: </label>
                                <select ref={register({})} className="search-input" name="ServiceType" defaultValue={filterData?.ServiceType ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="install">نصب</option>
                                    <option value="repair">تعمیر</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>بایگانی</label>
                                <select ref={register({})} className="search-input" name="IsArchive" defaultValue={filterData?.IsArchive ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>بایگانی نشده</option>
                                    <option value={true}>بایگانی شده</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>سند حسابداری: </label>
                                <select ref={register({})} className="search-input" name="HasDocument" defaultValue={filterData?.HasDocument ?? ""}>
                                    <option value="">انتخاب کنید</option>
                                    <option value={false}>سند حسابداری ندارد</option>
                                    <option value={true}>سند حسابداری دارد</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره سرویس: </label>
                                <input className="search-input" ref={register({})} name="InvoiceNumber" defaultValue={filterData?.InvoiceNumber ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="FirstContactDate"
                                    value={dateFilters.FirstContactDate ? momenJalaali(dateFilters.FirstContactDate) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, FirstContactDate: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ پذیرش تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="ContactDateTo"
                                    value={dateFilters.ContactDateTo ? momenJalaali(dateFilters.ContactDateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ContactDateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ رضایت سنجی از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="HappyCallDateFrom"
                                    value={dateFilters.HappyCallDateFrom ? momenJalaali(dateFilters.HappyCallDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, HappyCallDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ رضایت سنجی تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="search-input" name="HappyCallDateTo"
                                    value={dateFilters.HappyCallDateTo ? momenJalaali(dateFilters.HappyCallDateTo) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, HappyCallDateTo: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                        </Row>
                        <Button className="group-Btn-large mt-1" type="submit"><Search size={18} />&nbsp; جستجوی سرویس</Button>
                    </form>
                    {!pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" /></div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable rowButtons={rowButtons} columns={tableCols} objectName="happyCallServiceList" reducerName="happycallDataReducer" style={{ whiteSpace: "nowrap" }}
                        searchMethod={(data) => dispatch(searchServiceForHappyCall(data))} filterData={filterData} hasPaging={true} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default HappyCallServiceList;